/*  eslint no-shadow: ["error", { "allow": ["state"] }] */
/*  eslint no-param-reassign: ["error", { "props": false }] */
import Vue from "vue";
import Vuex from "vuex";
import { ServiceService } from "@/services/service.service";
import { HelperService } from "@/services/helper.service";

Vue.use(Vuex);

const state = {
  services: [],
  selected: {},
  loading: false,
  totalCount: 0
};

const getters = {
  services: state => state.services,
  selectedService: state => state.selected,
  onLoading: state => state.loading,
  total: state => state.totalCount
};

const mutations = {
  setSelected(state, sel) {
    state.selected = sel;
  },
  setList(state, sel) {
    state.services = sel;
  },
  setTotal(state, sel) {
    state.totalCount = Number(sel);
  },
  setLoading(state, sel) {
    state.loading = sel;
  }
};

const actions = {
  async ajaxServiceSetSelected({ commit }, payload) {
    await HelperService.genericSetSelected(
      commit,
      ServiceService.fetchOne,
      payload.id
    );
  },

  async ajaxServiceFetchAll({ commit }, payload) {
    let searchFilterPagination = HelperService.localToJSONAPIPagination(
      payload
    );
    searchFilterPagination.include = "tenant";

    await HelperService.genericFetchAll(
      commit,
      ServiceService.fetchAll,
      searchFilterPagination,
      null,
      null
    );
  },

  async ajaxServiceCreateOrUpdate({ commit }, payload) {
    return HelperService.genericCreateOrUpdate(
      commit,
      ServiceService.createOrUpdate,
      payload
    );
  },

  async ajaxServiceDelete({ commit }, payload) {
    return HelperService.genericDelete(
      commit,
      ServiceService.delete,
      payload.id
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
